import {
  Box,
  Chip,
  CircularProgress,
  Grid,
  IconButton,
  MenuItem,
  Typography,
} from "@mui/material";
import { OnboardingDialogsContext } from "contexts/OnboardingDialogs";
import { OutreachTemplatesContext } from "contexts/OutreachTemplates";
import { useContext } from "react";
import { CustomEvent } from "schemas/functions";
import { routes } from "schemas/routes";

import StyledSelect from "components/Styled/Select";
import TemplateEditButton from "components/TemplateEditButton";
import {
  Template,
  TemplateContentType,
} from "features/Influencer/ContactList/schema";
import { isPage } from "utils/general";

import styles from "./styles";

interface Props {
  followup?: Template;
  index: number;
  filteredFollowUps?: any[];
  templateFromEmailSettings?: number[];
  handleTemplateChange: (e: CustomEvent, index: number) => void;
  onRemove?: () => void;
  templatesError?: {
    idx: number;
    message: string;
  } | null;
  removeLoading?: boolean;
}

const FollowupSelect = ({
  followup,
  index,
  filteredFollowUps,
  templateFromEmailSettings,
  onRemove,
  handleTemplateChange,
  templatesError,
  removeLoading,
}: Props) => {
  const { setCurrentTemplateContentType, setCreateTemplateDialogOpen } =
    useContext(OutreachTemplatesContext);
  const { setCreateTemplateOnboardingDialogOpen } = useContext(
    OnboardingDialogsContext,
  );

  return (
    <Grid container alignItems={"center"}>
      <Grid item xs>
        <StyledSelect
          onChange={(e: CustomEvent) => {
            e.stopPropagation();
            handleTemplateChange(e, index + 1);
          }}
          onMouseUp={(e: CustomEvent) => {
            e.stopPropagation();
          }}
          value={followup?.id}
          fullWidth
        >
          <MenuItem
            onClick={() => {
              setCurrentTemplateContentType(TemplateContentType.FOLLOWUP);
              if (isPage(routes.onboardingPro)) {
                setCreateTemplateOnboardingDialogOpen(true);
              } else {
                setCreateTemplateDialogOpen(true);
              }
            }}
          >
            <Box sx={styles.createButton}>Create New</Box>
          </MenuItem>
          {filteredFollowUps?.map((template) => (
            <MenuItem key={template.id} value={template.id}>
              <Box
                display="flex"
                gap={1}
                flexWrap="wrap"
                sx={styles.templateName}
              >
                <Typography noWrap>
                  {template.name}

                  {template.id &&
                    templateFromEmailSettings?.includes(template.id) && (
                      <Chip
                        label="Last Used"
                        size="small"
                        sx={{
                          ml: 1,
                          fontSize: 10,
                          backgroundColor: "primary.light",
                        }}
                      />
                    )}
                </Typography>
              </Box>
            </MenuItem>
          ))}
        </StyledSelect>

        {templatesError && templatesError.idx === index && (
          <Typography
            sx={{ my: 2, color: "warning.main" }}
            textAlign={"center"}
          >
            <Box component="i" className="fa-regular fa-warning" />{" "}
            {templatesError.message}
          </Typography>
        )}
      </Grid>

      {followup?.id && (
        <Grid item xs="auto">
          {" "}
          <TemplateEditButton sx={{ ml: 1 }} templateId={followup.id} />
        </Grid>
      )}
      {onRemove && (
        <Grid item xs="auto">
          <IconButton
            sx={{ width: 20, height: 20, color: "purple.main", fontSize: 14 }}
            onClick={onRemove}
          >
            {removeLoading ? (
              <CircularProgress size={10} />
            ) : (
              <Box component="i" className="fa-regular fa-trash" />
            )}
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
};

export default FollowupSelect;
